// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ant-table-content{\n    color:rgb(68, 68, 68);\n    background: #d5dbdb ;\n    /* width: 900px; */\n}\n.tab-view-tkList{\n    width: 900px;\n}", ""]);
// Exports
module.exports = exports;
